<osn-cxb-dialog [title]="dialogTitle" class="content-page-dialog-container">
  <form [formGroup]="form">
    <mat-form-field *ngIf="!isLandingPage">
      <input
        matInput
        trim="blur"
        type="text"
        placeholder="Page internal name"
        autocomplete="off"
        formControlName="internalName"
        data-testid="content-page-dialog-internal-name-input"
      />
    </mat-form-field>
    <mat-form-field class="mt-3" *ngIf="!isLandingPage">
      <input
        matInput
        trim="blur"
        type="text"
        placeholder="Page name English"
        autocomplete="off"
        formControlName="tabTitleEnglish"
        data-testid="content-page-dialog-english-name-input"
      />
    </mat-form-field>
    <mat-form-field class="mt-3" *ngIf="!isLandingPage">
      <input
        matInput
        trim="blur"
        type="text"
        placeholder="Page name Arabic"
        autocomplete="off"
        formControlName="tabTitleArabic"
        data-testid="content-page-dialog-arabic-name-input"
      />
    </mat-form-field>
    <ng-container *ngIf="data.isGenrePage">
      <p class="select-label mt-3">Attached genre</p>
      <osn-cxb-genre-selector
        formControlName="attachedGenre"
        [filterGenres]="true"
        [disableMultiSelect]="true"
        [data-testid]="'content-page-dialog-genre-selector'"
      ></osn-cxb-genre-selector>
      <ng-template #showAttachedGenreName>
        <p class="attached-genre">ACTION</p>
      </ng-template>
    </ng-container>
    <h3 class="mt-3 seo-title">SEO related fields</h3>
    <mat-form-field class="mt-3">
      <input
        matInput
        trim="blur"
        type="text"
        placeholder="Page SEO title English"
        autocomplete="off"
        formControlName="SEOTitleEnglish"
        [required]="false"
      />
    </mat-form-field>
    <mat-form-field class="mt-3">
      <input
        matInput
        trim="blur"
        type="text"
        placeholder="Page SEO title Arabic"
        autocomplete="off"
        formControlName="SEOTitleArabic"
        [required]="false"
      />
    </mat-form-field>
    <mat-form-field class="multi-line mt-3">
      <textarea matInput placeholder="Page SEO description English" formControlName="SEODescriptionEnglish"></textarea>
    </mat-form-field>
    <mat-form-field class="multi-line mt-3">
      <textarea matInput placeholder="Page SEO description Arabic" formControlName="SEODescriptionArabic"></textarea>
    </mat-form-field>
    <div class="meta-groups mt-3" formArrayName="metaTags">
      <div class="meta-group" *ngFor="let _ of metaTags.controls; index as i">
        <ng-container [formGroupName]="i">
          <mat-form-field class="meta-key">
            <input trim="blur" matInput type="text" formControlName="key" placeholder="Meta tag (key)" autocomplete="off" />
          </mat-form-field>
          <mat-form-field>
            <input trim="blur" matInput type="text" formControlName="value" placeholder="Meta tag (value)" autocomplete="off" />
          </mat-form-field>
        </ng-container>
      </div>
    </div>
    <div *ngIf="data.variant !== PageDialogVariant.READ_ONLY" class="mt-2">
      <span class="add-meta" (click)="addNewMetaTag()">
        <svg-icon key="plus" class="inline-icon"></svg-icon>
        Add meta tag</span
      >
    </div>
    <div class="action">
      <button
        class="action-btn mt-4"
        data-testid="content-page-dialog-create-update-btn"
        type="button"
        [disabled]="form.invalid || !form.dirty"
        (click)="onSaveClick()"
      >
        {{ dialogAction }}
      </button>
    </div>
  </form>
</osn-cxb-dialog>
